// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const nit: CountryValidator<"GT"> = createValidator(
  "gt.nit",
  88,
);

export default nit;
export const compact = nit.compact;
export const format = nit.format;
export const validate = nit.validate;
export const generate = (): string =>
  nit.generate?.() ??
  (() => {
    throw new Error(
      "Validator gt.nit cannot generate values",
    );
  })();
